import React from "react";
import { Button, Modal, notification } from "tea-component";
import { useDblIntl } from "@/pages/datalab/utils/utils";
import { deleteTableSqlView } from "../service";

export default function DeleteModal(props: any) {
  const { gameCode, deleteInfo, setDeleteInfo, deleteCallBack } = props || {};
  const { visible, record } = deleteInfo || {};
  const { charts, table_id: tableId, table_name: tableName } = record || {};
  const isWarning = charts?.length > 0;
  const { dblFormatMessage, commonFormatMessage } = useDblIntl("sql_view");

  const deletedFunc = () => {
    const params = {
      game_code: gameCode,
      table_id: tableId,
    };
    deleteTableSqlView(params).then((res: any) => {
      deleteCallBack?.();
      notification.success({
        description: dblFormatMessage("delete_success"),
        duration: 3000
      });
    }).catch((e) => {
      notification.error({
        description: dblFormatMessage("delete_fail", { code: e?.code }),
        duration: 3000
      });
      console.log(e, "删除sql视图失败");
    });
  };

  if (!visible) return null;

  return (
    isWarning ? <Modal
      visible={visible}
      onClose={() => {
        setDeleteInfo({ visible: false, record: {} });
      }}
    >
      <Modal.Body className="modal-context" style={{ marginLeft: 0, marginRight: '40px' }}>
        <Modal.Message
          icon="error"
          message={<span className="dbl_text-strong">{dblFormatMessage("warning_to_delete_title")}</span>}
          description={dblFormatMessage("warning_to_delete_message", { name: <span className="dbl_text-strong">{tableName}</span>, number: charts?.length })}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            setDeleteInfo({ visible: false, record: {} });
          }}
        >
          {dblFormatMessage("i_know")}
        </Button>
      </Modal.Footer>
    </Modal> :
      <Modal
        visible={visible}
        onClose={() => {
          setDeleteInfo({ visible: false, record: {} });
        }}
      >
        <Modal.Body className="modal-context">
          <Modal.Message
            message={<span className="dbl_text-strong">{dblFormatMessage("sure_to_delete_title")}</span>}
            description={dblFormatMessage("sure_to_delete_message")}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setDeleteInfo({ visible: false, record: {} });
              deletedFunc();
            }}
          >
            {commonFormatMessage("confirm")}
          </Button>
          <Button
            type="weak"
            onClick={() => {
              setDeleteInfo({ visible: false, record: {} });
            }}
          >
            {commonFormatMessage("cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
  );
}